import React, { useState } from "react";
import {Helmet} from "react-helmet";
import "../../assets/css/idp-ug.css";
import IdpFormPg from "../../components/idp-ug-pg/idpFormPg";

const IdpPgPage = () => {
  const [domain, setDomain] = useState('')
  const getDomain = (data)=>{
    setDomain(data)
  }
  
  return (<>
    <Helmet>
        <title>IDP {domain}</title>
    </Helmet>
    <div className="idp_ug_pg_common idp_ug">
      <IdpFormPg getDomain={getDomain} />
    </div>
    </>);
};

export default IdpPgPage;
